
export default [
  {
    path: '/',
    meta: {
    },
    component: () => import('@/views/196/index')
  },
]

